import type { PropsWithChildren } from 'react'
import { type RecipeVariantProps, sva } from '~/styled-system/css'
import { Collapsible } from '~/ui/Collapsible'

const styles = sva({
  slots: ['container', 'trigger', 'title', 'content'],
  base: {
    trigger: {
      _pc: {
        cursor: 'pointer',
      },
    },
    title: {
      fontSize: 'base',
      fontWeight: 'bold',
      _pc: {
        fontSize: 'lg',
      },
    },
  },
  variants: {
    size: {
      lg: {
        title: {
          fontSize: 'lg',
        },
      },
    },
    border: {
      true: {
        trigger: {
          borderTop: 'medium',
          pt: '3',
          pb: '3',
          pr: '4',
        },
        title: {
          px: '4',
        },
        content: {
          px: '4',
        },
      },
    },
  },
})

export type VariantsProps = RecipeVariantProps<typeof styles>

export function CollapsibleContainer({
  title,
  children,
  ...variants
}: VariantsProps & PropsWithChildren<{ title: string }>) {
  const classes = styles(variants)
  return (
    <Collapsible
      header={<h3 className={classes.title}>{title}</h3>}
      size="small"
      color="neutral"
      className={classes.container}
      triggerClassName={classes.trigger}
      contentClassName={classes.content}
    >
      {children}
    </Collapsible>
  )
}
